module.exports = __webpack_public_path__ + "img/facebook-logo.09e9e7d.png";